module.exports = __webpack_public_path__ + "static/rabies-3187ee1f3f46053d19bb58e0a2601a2a.png";